import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
// import appIcon from './assets/app_icon.png';
// import huaweiMarketIcon from './assets/huawei_market_icon.png';

function HomePage() {
  useEffect(() => {
    // 滚动动画
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.scroll-fade').forEach(el => {
      observer.observe(el);
    });

    // 平滑滚动
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div id="app">
      <header>
        <nav className="container">
          <div className="logo"></div>
          <ul className="nav-links">
            <li><a href="#home">首页</a></li>
            <li><a href="#services">服务介绍</a></li>
            <li><a href="#cases">客户案例</a></li>
            <li><a href="#about">关于我们</a></li>
            <li><a href="#contact">联系我们</a></li>
          </ul>
        </nav>
      </header>

      <main>
        <section className="hero" id="home">
          <div className="container">
            <div className="hero-content">
              <h1>杭州斯代拉科技有限公司</h1>
              <p className="tagline">专业移动应用开发服务商</p>
              <p>为企业提供iOS/Android应用定制开发解决方案</p>
              <div className="hero-buttons">
                <a href="#services" className="btn-primary">查看服务</a>
                <a href="#contact" className="btn-secondary">立即咨询</a>
              </div>
            </div>
          </div>
        </section>

        <section className="services" id="services">
          <div className="container">
            <h2 className="section-title scroll-fade">移动应用开发服务</h2>
            <p className="services-intro scroll-fade">为企业提供专业的iOS/Android应用定制开发解决方案</p>

            <div className="service-packages">
              {/* 基础版 */}
              <div className="service-card scroll-fade">
                <div className="service-header">
                  <h3>基础版</h3>
                  <div className="price">¥8,800 起</div>
                </div>
                <div className="service-content">
                  <p className="service-desc">适合初创企业、简单应用需求</p>
                  <h4>服务内容：</h4>
                  <ul>
                    <li>基础功能开发（5-8个页面）</li>
                    <li>用户注册登录系统</li>
                    <li>基础数据管理</li>
                    <li>iOS或Android单平台</li>
                    <li>3个月技术支持</li>
                    <li>免费bug修复</li>
                  </ul>
                  <h4>交付周期：</h4>
                  <p>2-4周</p>
                  <button className="btn-consult" onClick={() => window.location.href='#contact'}>立即咨询</button>
                </div>
              </div>

              {/* 标准版 */}
              <div className="service-card scroll-fade featured">
                <div className="service-header">
                  <h3>标准版</h3>
                  <div className="price">¥18,800 起</div>
                  <span className="badge-popular">热门推荐</span>
                </div>
                <div className="service-content">
                  <p className="service-desc">适合中小企业、标准商业应用</p>
                  <h4>服务内容：</h4>
                  <ul>
                    <li>完整功能开发（10-15个页面）</li>
                    <li>用户系统+支付集成</li>
                    <li>后台管理系统</li>
                    <li>iOS+Android双平台</li>
                    <li>6个月技术支持</li>
                    <li>免费功能优化</li>
                  </ul>
                  <h4>交付周期：</h4>
                  <p>4-6周</p>
                  <button className="btn-consult" onClick={() => window.location.href='#contact'}>立即咨询</button>
                </div>
              </div>

              {/* 定制版 */}
              <div className="service-card scroll-fade">
                <div className="service-header">
                  <h3>定制版</h3>
                  <div className="price">面议</div>
                </div>
                <div className="service-content">
                  <p className="service-desc">适合大型企业、复杂业务需求</p>
                  <h4>服务内容：</h4>
                  <ul>
                    <li>完全定制化开发</li>
                    <li>复杂业务逻辑实现</li>
                    <li>第三方系统对接</li>
                    <li>全平台支持</li>
                    <li>12个月技术支持</li>
                    <li>专属技术团队</li>
                  </ul>
                  <h4>交付周期：</h4>
                  <p>根据需求评估</p>
                  <button className="btn-consult" onClick={() => window.location.href='#contact'}>立即咨询</button>
                </div>
              </div>
            </div>

            {/* 服务流程 */}
            <div className="service-process scroll-fade">
              <h3>服务流程</h3>
              <div className="process-steps">
                <div className="step">
                  <div className="step-number">1</div>
                  <h4>需求沟通</h4>
                  <p>详细了解您的需求和预期目标</p>
                </div>
                <div className="step">
                  <div className="step-number">2</div>
                  <h4>方案设计</h4>
                  <p>提供技术方案和报价</p>
                </div>
                <div className="step">
                  <div className="step-number">3</div>
                  <h4>签订合同</h4>
                  <p>明确双方权责，支付首期款项</p>
                </div>
                <div className="step">
                  <div className="step-number">4</div>
                  <h4>开发实施</h4>
                  <p>按计划开发，定期汇报进度</p>
                </div>
                <div className="step">
                  <div className="step-number">5</div>
                  <h4>测试验收</h4>
                  <p>功能测试，客户验收确认</p>
                </div>
                <div className="step">
                  <div className="step-number">6</div>
                  <h4>上线运维</h4>
                  <p>协助上线，提供售后支持</p>
                </div>
              </div>
            </div>

            {/* 售后服务保障 */}
            <div className="service-guarantee scroll-fade">
              <h3>售后服务与保障</h3>
              <div className="guarantee-grid">
                <div className="guarantee-item">
                  <div className="guarantee-icon">🛡️</div>
                  <h4>质量保证</h4>
                  <p>严格的代码审查和测试流程，确保交付质量</p>
                </div>
                <div className="guarantee-item">
                  <div className="guarantee-icon">🔧</div>
                  <h4>免费维护</h4>
                  <p>项目上线后提供免费维护期，修复功能性问题</p>
                </div>
                <div className="guarantee-item">
                  <div className="guarantee-icon">📞</div>
                  <h4>技术支持</h4>
                  <p>提供电话、QQ等多渠道技术支持，工作日内响应</p>
                </div>
                <div className="guarantee-item">
                  <div className="guarantee-icon">📝</div>
                  <h4>源码交付</h4>
                  <p>项目完成后交付完整源代码和技术文档</p>
                </div>
              </div>
            </div>

            {/* 退款政策 */}
            <div className="refund-policy scroll-fade">
              <h3>退款政策</h3>
              <div className="policy-content">
                <div className="policy-section">
                  <h4>可全额退款情况：</h4>
                  <ul>
                    <li>项目启动前（签约后7天内未开始开发）</li>
                    <li>因我方原因无法按时交付</li>
                    <li>交付产品与合同约定严重不符</li>
                  </ul>
                </div>
                <div className="policy-section">
                  <h4>可部分退款情况：</h4>
                  <ul>
                    <li>项目进行中客户要求终止（按已完成工作量结算）</li>
                    <li>客户需求变更导致项目终止（扣除已投入成本）</li>
                  </ul>
                </div>
                <div className="policy-section">
                  <h4>客户投诉处理：</h4>
                  <p>如对服务有任何不满，请通过以下方式联系我们：</p>
                  <ul>
                    <li>客服电话：15000416741</li>
                    <li>客服QQ：454784911</li>
                    <li>邮箱：454784911@qq.com</li>
                  </ul>
                  <p>我们承诺24小时内响应，48小时内给出解决方案。</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 客户案例板块 */}
        <section className="cases" id="cases">
          <div className="container">
            <h2 className="section-title scroll-fade">客户案例</h2>
            <p className="cases-intro scroll-fade">已为多家企业提供专业的软件产品和技术服务</p>

            <div className="cases-grid">
              {/* 案例1 */}
              <div className="case-card scroll-fade">
                <div className="case-header">
                  <h3>某教育机构在线预约系统</h3>
                  <span className="case-date">2024年10月</span>
                </div>
                <div className="case-content">
                  <p className="case-desc">为某知名教育培训机构定制开发在线课程预约系统，支持多校区、多课程的预约管理，大幅提升了运营效率。</p>
                  <div className="case-tags">
                    <span className="case-tag">在线预约</span>
                    <span className="case-tag">课程管理</span>
                    <span className="case-tag">数据统计</span>
                  </div>
                  <div className="case-tech">
                    <strong>技术栈：</strong>React + Node.js + MySQL
                  </div>
                </div>
              </div>

              {/* 案例2 */}
              <div className="case-card scroll-fade">
                <div className="case-header">
                  <h3>某电商企业小程序商城</h3>
                  <span className="case-date">2024年9月</span>
                </div>
                <div className="case-content">
                  <p className="case-desc">为某本地生活服务企业开发微信小程序商城，集成支付、订单、会员等功能，上线首月GMV突破50万。</p>
                  <div className="case-tags">
                    <span className="case-tag">小程序</span>
                    <span className="case-tag">电商系统</span>
                    <span className="case-tag">支付集成</span>
                  </div>
                  <div className="case-tech">
                    <strong>技术栈：</strong>微信小程序 + Java + Redis
                  </div>
                </div>
              </div>

              {/* 案例3 */}
              <div className="case-card scroll-fade">
                <div className="case-header">
                  <h3>某科技公司CRM系统</h3>
                  <span className="case-date">2024年8月</span>
                </div>
                <div className="case-content">
                  <p className="case-desc">为某B2B科技公司部署CRM客户管理系统，实现客户信息统一管理、销售流程跟进，客户转化率提升30%。</p>
                  <div className="case-tags">
                    <span className="case-tag">CRM</span>
                    <span className="case-tag">销售管理</span>
                    <span className="case-tag">数据分析</span>
                  </div>
                  <div className="case-tech">
                    <strong>技术栈：</strong>Vue.js + Python + PostgreSQL
                  </div>
                </div>
              </div>

              {/* 案例4 */}
              <div className="case-card scroll-fade">
                <div className="case-header">
                  <h3>某连锁企业智能客服系统</h3>
                  <span className="case-date">2024年7月</span>
                </div>
                <div className="case-content">
                  <p className="case-desc">为某连锁服务企业部署智能客服机器人，实现7x24小时自动回复，客服人力成本降低60%。</p>
                  <div className="case-tags">
                    <span className="case-tag">智能客服</span>
                    <span className="case-tag">自动回复</span>
                    <span className="case-tag">微信集成</span>
                  </div>
                  <div className="case-tech">
                    <strong>技术栈：</strong>Node.js + 微信API + MongoDB
                  </div>
                </div>
              </div>

              {/* 案例5 */}
              <div className="case-card scroll-fade">
                <div className="case-header">
                  <h3>某制造企业数据看板</h3>
                  <span className="case-date">2024年6月</span>
                </div>
                <div className="case-content">
                  <p className="case-desc">为某制造企业开发生产数据可视化看板，实时展示生产进度、设备状态、质量指标，助力数字化管理。</p>
                  <div className="case-tags">
                    <span className="case-tag">数据可视化</span>
                    <span className="case-tag">实时监控</span>
                    <span className="case-tag">报表系统</span>
                  </div>
                  <div className="case-tech">
                    <strong>技术栈：</strong>React + ECharts + InfluxDB
                  </div>
                </div>
              </div>
            </div>

            <div className="cases-stats scroll-fade">
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">服务客户</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100+</div>
                <div className="stat-label">交付项目</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">98%</div>
                <div className="stat-label">客户满意度</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">3年</div>
                <div className="stat-label">行业经验</div>
              </div>
            </div>
          </div>
        </section>

        {/* 注释掉软件外包服务部分 */}
        {/*
        <section className="services" id="services">
          <div className="container">
            <h2 className="section-title scroll-fade">软件外包服务</h2>
            <div className="service-intro scroll-fade">
              <p>杭州斯代拉科技有限公司提供专业的软件定制开发服务，拥有经验丰富的技术团队，为企业和个人提供从需求分析到上线运维的全流程技术解决方案。</p>
            </div>

            <div className="service-packages">
              <div className="service-card scroll-fade">
                <div className="service-header">
                  <h3>移动应用开发</h3>
                  <div className="price">¥30,000 起</div>
                </div>
                <div className="service-content">
                  <h4>服务内容：</h4>
                  <ul>
                    <li>iOS/Android 原生应用开发</li>
                    <li>跨平台应用开发（Flutter/React Native）</li>
                    <li>UI/UX 设计</li>
                    <li>应用上架协助</li>
                    <li>3个月免费维护期</li>
                  </ul>
                  <h4>交付周期：</h4>
                  <p>1-3个月（根据项目复杂度）</p>
                </div>
              </div>

              <div className="service-card scroll-fade">
                <div className="service-header">
                  <h3>Web系统开发</h3>
                  <div className="price">¥20,000 起</div>
                </div>
                <div className="service-content">
                  <h4>服务内容：</h4>
                  <ul>
                    <li>企业官网/管理系统开发</li>
                    <li>电商平台开发</li>
                    <li>响应式网页设计</li>
                    <li>后台管理系统</li>
                    <li>3个月免费维护期</li>
                  </ul>
                  <h4>交付周期：</h4>
                  <p>2-8周（根据项目复杂度）</p>
                </div>
              </div>

              <div className="service-card scroll-fade">
                <div className="service-header">
                  <h3>小程序开发</h3>
                  <div className="price">¥15,000 起</div>
                </div>
                <div className="service-content">
                  <h4>服务内容：</h4>
                  <ul>
                    <li>微信小程序开发</li>
                    <li>支付宝小程序开发</li>
                    <li>UI设计与交互优化</li>
                    <li>小程序上线协助</li>
                    <li>3个月免费维护期</li>
                  </ul>
                  <h4>交付周期：</h4>
                  <p>3-6周（根据项目复杂度）</p>
                </div>
              </div>
            </div>

            <div className="service-process scroll-fade">
              <h3>服务流程</h3>
              <div className="process-steps">
                <div className="step">
                  <div className="step-number">1</div>
                  <h4>需求沟通</h4>
                  <p>详细了解您的需求和预期目标</p>
                </div>
                <div className="step">
                  <div className="step-number">2</div>
                  <h4>方案设计</h4>
                  <p>提供技术方案和报价</p>
                </div>
                <div className="step">
                  <div className="step-number">3</div>
                  <h4>签订合同</h4>
                  <p>明确双方权责，支付首期款项</p>
                </div>
                <div className="step">
                  <div className="step-number">4</div>
                  <h4>开发实施</h4>
                  <p>按计划开发，定期汇报进度</p>
                </div>
                <div className="step">
                  <div className="step-number">5</div>
                  <h4>测试验收</h4>
                  <p>功能测试，客户验收确认</p>
                </div>
                <div className="step">
                  <div className="step-number">6</div>
                  <h4>上线运维</h4>
                  <p>协助上线，提供售后支持</p>
                </div>
              </div>
            </div>

            <div className="service-guarantee scroll-fade">
              <h3>售后服务与保障</h3>
              <div className="guarantee-grid">
                <div className="guarantee-item">
                  <div className="guarantee-icon">🛡️</div>
                  <h4>质量保证</h4>
                  <p>严格的代码审查和测试流程，确保交付质量</p>
                </div>
                <div className="guarantee-item">
                  <div className="guarantee-icon">🔧</div>
                  <h4>免费维护</h4>
                  <p>项目上线后提供3个月免费维护期，修复功能性问题</p>
                </div>
                <div className="guarantee-item">
                  <div className="guarantee-icon">📞</div>
                  <h4>技术支持</h4>
                  <p>提供电话、微信等多渠道技术支持，工作日内响应</p>
                </div>
                <div className="guarantee-item">
                  <div className="guarantee-icon">📝</div>
                  <h4>源码交付</h4>
                  <p>项目完成后交付完整源代码和技术文档</p>
                </div>
              </div>
            </div>

            <div className="service-contact scroll-fade">
              <h3>联系我们获取定制方案</h3>
              <div className="contact-info">
                <div className="contact-item">
                  <span className="contact-label">咨询电话：</span>
                  <span className="contact-value">17328852722</span>
                </div>
                <div className="contact-item">
                  <span className="contact-label">工作时间：</span>
                  <span className="contact-value">周一至周五 9:00-18:00</span>
                </div>
                <div className="contact-item">
                  <span className="contact-label">客诉处理：</span>
                  <span className="contact-value">如对服务有任何不满，请致电上述电话，我们将在24小时内响应并提供解决方案</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        */}

        <section className="about" id="about">
          <div className="container">
            <div className="about-content scroll-fade">
              <div className="about-text">
                <h2>关于我们</h2>
                <p>杭州斯代拉科技有限公司成立于2020年，是一家专注于移动应用开发的科技企业。</p>
                <p>我们致力于为企业提供专业的iOS/Android应用开发解决方案，帮助客户实现数字化转型。</p>
                <p>公司拥有专业的技术团队，秉承"专业、创新、可靠"的理念，为客户创造价值。</p>
              </div>

              <div className="values">
                <div className="value-item">
                  <div className="value-icon">💡</div>
                  <h4>专业品质</h4>
                  <p>注重产品细节与用户体验</p>
                </div>
                <div className="value-item">
                  <div className="value-icon">🚀</div>
                  <h4>持续创新</h4>
                  <p>探索新技术，创造新价值</p>
                </div>
                <div className="value-item">
                  <div className="value-icon">🎯</div>
                  <h4>用户至上</h4>
                  <p>以用户需求为产品导向</p>
                </div>
              </div>
            </div>

            {/* 公司资质展示 */}
            <div className="qualifications scroll-fade">
              <h3>公司资质</h3>
              <div className="qualification-grid">
                <div className="qualification-item">
                  <div className="qualification-icon">📜</div>
                  <h4>营业执照</h4>
                  <p>统一社会信用代码</p>
                  <p className="qualification-detail">正规注册企业</p>
                </div>
                <div className="qualification-item">
                  <div className="qualification-icon">🏆</div>
                  <h4>软件企业</h4>
                  <p>专业软件开发资质</p>
                  <p className="qualification-detail">技术服务认证</p>
                </div>
                <div className="qualification-item">
                  <div className="qualification-icon">✅</div>
                  <h4>ICP备案</h4>
                  <p>浙ICP备2023022128号</p>
                  <p className="qualification-detail">合法合规运营</p>
                </div>
                <div className="qualification-item">
                  <div className="qualification-icon">🔒</div>
                  <h4>信息安全</h4>
                  <p>数据安全保障</p>
                  <p className="qualification-detail">隐私保护承诺</p>
                </div>
              </div>
            </div>

            {/* 服务保障 */}
            <div className="service-guarantee-section scroll-fade">
              <h3>服务保障</h3>
              <div className="guarantee-list">
                <div className="guarantee-item-inline">
                  <span className="guarantee-check">✓</span>
                  <span>正规注册企业，工商可查</span>
                </div>
                <div className="guarantee-item-inline">
                  <span className="guarantee-check">✓</span>
                  <span>所有产品提供完整源码</span>
                </div>
                <div className="guarantee-item-inline">
                  <span className="guarantee-check">✓</span>
                  <span>3个月免费技术支持</span>
                </div>
                <div className="guarantee-item-inline">
                  <span className="guarantee-check">✓</span>
                  <span>支持定制化开发需求</span>
                </div>
                <div className="guarantee-item-inline">
                  <span className="guarantee-check">✓</span>
                  <span>私有化部署，数据安全</span>
                </div>
                <div className="guarantee-item-inline">
                  <span className="guarantee-check">✓</span>
                  <span>签订正规技术服务合同</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer id="contact">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>联系我们</h4>
              <p>咨询热线：15000416741</p>
              <p>客服QQ：454784911</p>
              <p>电子邮箱：454784911@qq.com</p>
              <p>工作时间：周一至周五 9:00-18:00</p>
            </div>
            <div className="footer-section">
              <h4>公司地址</h4>
              <p>浙江省杭州市余杭区高教镇凤仪大道966号2号楼6层603室6414室</p>
            </div>
            <div className="footer-section">
              <h4>法律信息</h4>
              <p>公司名称：杭州斯代拉科技有限公司</p>
              <p><a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">浙ICP备2023022128号</a></p>
              <p className="footer-links">
                <Link to="/support">技术支持</Link> |
                <Link to="/terms">服务条款</Link> |
                <Link to="/privacy">隐私政策</Link> |
                <Link to="/refund">退款政策</Link>
              </p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024-2026 杭州斯代拉科技有限公司. 保留所有权利.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;
